import React from 'react';
import { dictionary } from '../../dictionary';
import MinorProjects from './MinorProjects';

const INTReportTable = (props) => {
  const { properties, styles } = props;
  const stagesDev = properties.eldData[0].stages_development.concat({ name: 'Other' });
  const hoursSum = properties.logsToDisplay.reduce((total, obj) => total + (obj.hours || 0), 0);
  const learningConceptSum = properties.logsToDisplay.reduce((total, obj) => total + (obj.learning_concept || 0), 0);
  const storyboardSum = properties.logsToDisplay.reduce((total, obj) => total + (obj.storyBoard || 0), 0);
  const visualVersionSum = properties.logsToDisplay.reduce((total, obj) => total + (obj.visual_version || 0), 0);
  const clickableVersionSum = properties.logsToDisplay.reduce((total, obj) => total + (obj.clickable_version || 0), 0);
  const adaptChangesSum = properties.logsToDisplay.reduce((total, obj) => total + (obj.adapt_changes || 0), 0);
  const finalVersionSum = properties.logsToDisplay.reduce((total, obj) => total + (obj.final_version || 0), 0);
  const qCSum = properties.logsToDisplay.reduce((total, obj) => total + (obj.qc || 0), 0);
  const signOff = properties.logsToDisplay.reduce((total, obj) => total + (obj.sign_off || 0), 0);
  const other = properties.logsToDisplay.reduce((total, obj) => total + (obj.other || 0), 0);

  const sumValues = properties.logsToDisplay.reduce((acc, log) => {
    if (!acc[log.module]) {
      acc[log.module] = 0;
    }
    acc[log.module] += log.hours || 0;
    return acc;
  }, {});

  const sumValuesArray = Object.values(sumValues);

  const tableObjDev = {
    learning_concept: learningConceptSum,
    storyBoard: storyboardSum,
    visual_version: visualVersionSum,
    clickable_version: clickableVersionSum,
    adapt_changes: adaptChangesSum,
    final_version: finalVersionSum,
    qc: qCSum,
    sign_off: signOff,
    other: other,
  };

  const getStageKey = (stageName) => {
    if (stageName === 'Learning Concept') return 'learning_concept';
    if (stageName === 'Storyboard') return 'storyBoard';
    if (stageName === 'Visual Version') return 'visual_version';
    if (stageName === 'Clickable Version') return 'clickable_version';
    if (stageName === 'Adapt Changes') return 'adapt_changes';
    if (stageName === 'Final Version') return 'final_version';
    if (stageName === 'QC') return 'qc';
    if (stageName === 'Sign-off' || stageName === 'Sign_off') return 'sign_off';
    if (stageName === 'Other') return 'other';
    return stageName.toLowerCase().replace(/[-\s]+/g, '_');
  };

  return (
    <>
      <thead>
        <tr>
          <th></th>
          {properties.logsToDisplay.map((log, index) => {
            return (
              <th key={index} className="header" style={styles.header}>
                {log.module}
              </th>
            );
          })}
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>{dictionary.export_table_th_dev}</td>
        </tr>
        {stagesDev.map((stage, index) => {
          const stageKey = getStageKey(stage.name);
          return (
            <tr key={index} style={index % 2 === 0 ? styles.green : styles.blue}>
              <th className="thdefault" style={styles.thdefault}>
                {stage.name}
              </th>
              {properties.logsToDisplay.map((log, logIndex) => {
                // Sprawdzamy czy dany moduł ma jakieś godziny dla tego stage'a
                const hoursForStage = log[stageKey] || log[stage.name];

                if (hoursForStage && hoursForStage > 0) {
                  return (
                    <td key={logIndex} className="tddefault" style={styles.tddefault}>
                      {hoursForStage.toString().replace('.', ',')}
                    </td>
                  );
                }
                return (
                  <td key={logIndex} className="tddefault" style={styles.tddefault}>
                    {''}
                  </td>
                );
              })}
            </tr>
          );
        })}
        <tr className="orange" style={styles.orange}>
          <td className="orange" style={styles.orange}>
            Development - {new Date().getFullYear()} fiscal only
          </td>
          {sumValuesArray.map((sum, index) => (
            <td key={index} className="orange" style={styles.orange}>
              {sum.toString().replace('.', ',')}
            </td>
          ))}
        </tr>
        <tr>
          <th>{dictionary.export_table_th_dev}</th>
        </tr>
        {Object.keys(tableObjDev).map((key, index) => (
          <tr key={index}>
            <th className="gray" style={styles.gray}>
              {key}
            </th>
            <td key={key} className="tddefault" style={styles.tddefault}>
              {tableObjDev[key].toString().replace('.', ',')}
            </td>
          </tr>
        ))}
        <tr>
          <th className="gray" style={styles.gray}>
            {dictionary.export_table_summary}
          </th>
          <td className="orange" style={styles.orange}>
            {hoursSum.toString().replace('.', ',')}
          </td>
          <td>{<MinorProjects properties={properties} />}</td>
        </tr>
      </tbody>
    </>
  );
};

export default INTReportTable;
